import { render, staticRenderFns } from "./select-political.vue?vue&type=template&id=4ced3ba9&scoped=true"
import script from "./select-political.vue?vue&type=script&lang=js"
export * from "./select-political.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced3ba9",
  null
  
)

export default component.exports